import { createFileRoute } from '@tanstack/react-router';
import { useActiveRealmAPIContext } from '@interxfi/api-client/realm-context';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { BanksimCreateInboundDrawer } from '../../../../../../../../../../features/banksim/inbound/banksim-create-inbound-drawer';
import { PaymentsAchTable } from '../../../../../../../../../../features/payments/ach/payments-ach-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingFinancePayments,
      label: 'ACH',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingFinancePayments>,
  head: () => getPageHead('ACH Payments'),
  component: PaymentsAchList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  const { activeRealmIsSimulated, activeTenantIsClearing } = useActiveRealmAPIContext();

  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {activeTenantIsClearing && activeRealmIsSimulated ? (
            <RequiresAccess write>
              <BanksimCreateInboundDrawer
                trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Simulated Inbound Transfer" size="small" />}
              />
            </RequiresAccess>
          ) : null}

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingFinancePayments}
    />
  );
}

function PaymentsAchList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <PaymentsAchTable HeaderActions={TableHeader} view={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
